import type { ApplianceId } from "~domain/devices/models/appliances/appliance-model.ts";
import type { ModulatorLinkCsId, ModulatorLinkHwId } from "~domain/devices/models/links/link-model.ts";

import { z } from "zod";

export const backofficeFindAppliancesResponseSchema = z
  .object({
    appliance: z.object({
      id: z.number(),
      description: z.string(),
    }),
    applianceReference: z.object({
      id: z.number(),
      description: z.string(),
    }),
    creationDatetime: z.coerce.date(),
    csLinkId: z.number().transform((s) => s as ModulatorLinkCsId),
    description: z.string().nullable(),
    hwLinkId: z.number().transform((s) => s as ModulatorLinkHwId),
    id: z
      .number()
      .transform((s) => s as ApplianceId)
      .nullable(), // Because why not ???
    isProducer: z.boolean(),
    producer: z.boolean(), // ofc, isProducer and producer, just to be sure the front catch it
    localisation: z.string().nullable(),
    nominalPower: z.number().nullable(),
  })
  .array();

export type BackofficeFindAppliancesResponse = z.infer<typeof backofficeFindAppliancesResponseSchema>;
